import { useMemo } from 'react';
import HRDashboard from './HRDashboard';
import EmployeeSelfService from './EmployeeSelfService';

export default function HRDashboardWrapper() {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  
  // Check if user is admin
  const isAdmin = useMemo(() => {
    const role = userData.role || '';
    return ['super_admin', 'platform_admin', 'hr_admin', 'admin'].includes(role);
  }, [userData.role]);

  // Render appropriate dashboard based on role
  if (isAdmin) {
    return <HRDashboard />;
  }
  
  return <EmployeeSelfService />;
}
